import { Link } from "react-router-dom";
import { siteInfo, categories } from "@/mocks/data";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3
              className="text-xl font-bold mb-4"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              {siteInfo.logo}
            </h3>
            <p className="text-sm text-white/60 leading-relaxed">
              大满贯官方网址入口平台，提供最新正版大满贯平台地址直达链接，安全稳定无跳转。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">游戏分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  网站首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  用户协议
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  免责声明
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-white/90">联系我们</h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-phone-line text-primary-400"></i>
                {siteInfo.contact.phone}
              </li>
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-mail-line text-primary-400"></i>
                {siteInfo.contact.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-wechat-line text-primary-400"></i>
                {siteInfo.contact.wechat}
              </li>
              <li className="flex items-center gap-2 text-sm text-white/60">
                <i className="ri-time-line text-primary-400"></i>
                {siteInfo.contact.workingHours}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-white/40">
            &copy; {siteInfo.year} {siteInfo.name} 版权所有
          </p>
          <p className="text-sm text-white/40">
            温馨提示：理性游戏，娱乐为主
          </p>
        </div>
      </div>
    </footer>
  );
}